import { getRouter } from '@/router/router'
import { PartySearch } from '@/party/PartySearch'
import { PartyAlbumPage } from '@/party/PartyAlbumPage'
import { PartyArtistPage } from '@/party/PartyArtistPage'

export function registerPartyRoutes() {
    const stage = document.querySelector('.partyStage') as HTMLElement
    getRouter().configure({
        stage,
        routes: [
            {
                pattern: '/',
                paramNames: [],
                factory: () => PartySearch(),
            },
            {
                pattern: '/album/:albumId',
                paramNames: ['albumId'],
                factory: ({ albumId }) => PartyAlbumPage({ albumId }),
            },
            {
                pattern: '/artist/:artistId',
                paramNames: ['artistId'],
                factory: ({ artistId }) => PartyArtistPage({ artistId }),
            },
        ],
    })
}
